import { render } from "./SelectableCard.vue?vue&type=template&id=cbc9afa0"
import script from "./SelectableCard.vue?vue&type=script&lang=js"
export * from "./SelectableCard.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/abdom-booking/abdom-booking/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__